import React from "react";
import { Route, Routes } from "react-router-dom";
import { StockItemDetails, StockItemsList } from "./containers";

export const StockItems = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<StockItemsList />} />
        <Route path="details/:id" element={<StockItemDetails />} />
      </Routes>
    </>
  );
};
